module.exports = __webpack_public_path__ + "img/back button diameter.f6151d69.png";